(async () => {
    const { Core } = await importModule('Core');
    const { fetchHTML, $replaceContent } = await importModule('Utils');

    customElements.define('faq-elements', class extends Core {

        elements = {
            buttons: '[data-accordion-title]',
            accordionBody: '[data-accordion-body]',
        }

        render() {
            document.querySelectorAll(this.elements.buttons)?.forEach((button)=>{
                button.addEventListener('click',this._handleOpenAccordion)
            })
        }

        _handleOpenAccordion (e) {
            const body = this.nextElementSibling
            this.getAttribute('aria-expanded') === 'false' ? this.setAttribute('aria-expanded','true') : this.setAttribute('aria-expanded','false')
            body.classList.toggle('open') 
        } 
        
    })
})();